import axios from 'axios'
import React, { useEffect, useState } from 'react'
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import { Grid, TablePagination, TextField } from '@mui/material';
import {SyncLoader} from 'react-spinners'


function MainStoreSales() {


    const[sales,setSales] = useState([])
    const [search,setSearch] = useState('')
    const [loading,setLoading] = useState(true)
    const [waraTotal,setWaraTotal] = useState(0)
    const [waraGrossTotal,setWaraGrossTotal] = useState(0)
    const [waraDiscountTotal,setWaraDiscountTotal] = useState(0)
    const [page, setPage] = useState(0)
    const [rowsPerPage, setRowsPerPage] = useState(25)
    const [totalRows, setTotalRows] = useState(0)

    var currentDate = new Date();
    currentDate.setDate(1);
    var startDateOfMonth = currentDate.toISOString().split('T')[0];
  
    var todayDate = new Date().toISOString().split('T')[0];
      const [startDate,setStartDate] = useState(startDateOfMonth)
      const [endDate,setEndDate] = useState(todayDate)


    useEffect(() => {
      const data = {
        from_date : startDate,
        to_date : endDate
      }

      axios.post("https://bmserver.ccsoftwares.com/Sales/setTotalSalesStorewise",data).then(res => {
        if (res.data) {
          res.data.store_sales.map((e,i) =>{
            if(e.store === "Warakapola"){
              setWaraTotal(e.net_total)
              setWaraGrossTotal(e.gross_total)
              setWaraDiscountTotal(e.discount)
            }
          })
        }else{
          setWaraTotal(0)
        }
      })
      
    }, [endDate, startDate])

    useEffect(() => {
      setLoading(true);
      const data = {
        page: page + 1,
        limit: rowsPerPage,
        search,
        store: 'Warakapola',
        from_date: startDate,
        to_date: endDate
      };

      axios.post("https://bmserver.ccsoftwares.com/Sales/paginated", data).then(res => {
        setSales(res.data?.data || []);
        setTotalRows(res.data?.pagination?.total || 0);
        setLoading(false);
      }).catch(err => {
        console.error(err);
        setSales([]);
        setTotalRows(0);
        setLoading(false);
      })
    }, [endDate, page, rowsPerPage, search, startDate])


    const formatCurrency = (value) => {
      return new Intl.NumberFormat('en-US', {
          style: 'currency',
          currency: 'LKR', // Change to your desired currency code
          minimumFractionDigits: 2,
          maximumFractionDigits: 2
      }).format(value);
  };
    
    



  return (
    <>
    <div style={{backgroundColor  :'white',width : '100%',marginLeft : 10}}>
        <h1>Warakapola Sales</h1>
        <Grid container spacing={2}>

 
                <Grid item md={5} xs={12}>
                    <TextField
                        placeholder=''
                        type='date'
                        variant="outlined"
                        margin="normal"
                        required
                        fullWidth
                        label="Date from "
                        value={startDate}
                        InputLabelProps={{
                            shrink: true
                        }}
                        onChange={(e) => {
                          setStartDate(e.target.value);
                          setPage(0);
                        }}
                        >
                    </TextField>
                </Grid>
                <Grid item md={5} xs={12}>
                    <TextField
                        placeholder=''
                        type='date'
                        variant="outlined"
                        margin="normal"
                        required
                        fullWidth
                        label="Date To "
                        value={endDate}
                        InputLabelProps={{
                            shrink: true
                        }}
                        onChange={(e) => {
                          setEndDate(e.target.value);
                          setPage(0);
                        }}
                        >
                    </TextField>
                </Grid>
                <Grid item md={2} xs={12}>
                    <div style={{justifyContent : 'center',alignItems : 'center',textAlign : 'left',height : '100%',display : 'flex',fontSize : 16}}>
                      Gross Total :{formatCurrency(waraGrossTotal)} <br></br>
                      Discount Total :{formatCurrency(waraDiscountTotal)} <br></br>
                      Net Total :{formatCurrency(waraTotal)} 
                    </div>
                </Grid>
                </Grid>
        <TextField
          id="standard-basic"
          label="Search by Invoice No / Product name"
          variant="standard"
          onChange={(e) => {
            setSearch(e.target.value);
            setPage(0);
          }}
          fullWidth
          autoComplete="off"
        />
    </div>
    {loading ? (
      <div style={{display : 'flex',justifyContent : 'center',alignItems : 'center',height : '100vh'}}>
        <SyncLoader color="#1e1e1e" />
      </div>
    ) : (

      
      <div style={{display : 'flex',justifyContent : 'center',marginTop : 70}}>
    <TableContainer component={Paper}>
      <Table aria-label="sales table">
        <TableHead>
          <TableRow>
            <TableCell>#</TableCell>
            <TableCell>Invoice No</TableCell>
            <TableCell>Product Name</TableCell>
            <TableCell>Qty</TableCell>
            <TableCell>Cashier</TableCell>
            <TableCell>Gross Total</TableCell>
            <TableCell>Net Total</TableCell>
            <TableCell>Discount</TableCell>
            <TableCell>Shop</TableCell>
            <TableCell>Bill Date /Time</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {sales.map((e, i) => (
            <TableRow key={`${e.invoice_no}-${i}`}>
              <TableCell>{page * rowsPerPage + i + 1}</TableCell>
              <TableCell>{e.invoice_no}</TableCell>
              <TableCell>{e.product_name}</TableCell>
              <TableCell>{e.qty}</TableCell>
              <TableCell>{e.cashier}</TableCell>
              <TableCell>Rs.{e.gross_total}.00</TableCell>
              <TableCell>Rs.{e.net_total}.00</TableCell>
              <TableCell>Rs.{e.discount}.00</TableCell>
              <TableCell>{e.store}</TableCell>
              <TableCell>{e.bill_date.split('T')[0]} / {e.bill_time}</TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
      <TablePagination
        component="div"
        count={totalRows}
        page={page}
        onPageChange={(event, newPage) => setPage(newPage)}
        rowsPerPage={rowsPerPage}
        onRowsPerPageChange={(event) => {
          setRowsPerPage(parseInt(event.target.value, 10));
          setPage(0);
        }}
        rowsPerPageOptions={[10, 25, 50, 100]}
      />
    </TableContainer>
        </div>
    )}



    </>


  )
}

export default MainStoreSales
